module.exports = __webpack_public_path__ + "static/js/0.89ec3fdf.chunk.worker.js"